/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */
import {AfterContentChecked, ChangeDetectorRef, Component, DoCheck, Input, OnInit, ViewChild} from '@angular/core';
import {Driver} from "../model/Driver";
import {Accident} from "../model/Accident";
import {ActivatedRoute} from "@angular/router";
import {DriverService} from "../services/driver.service";
import {AccidentsService} from "../services/accidents.service";
import {AccidentClassificationService} from "../services/accident-classification.service";
import {AccidentCausationService} from "../services/accident-causation.service";
import {LocationsService} from "../services/locations.service";
import {LocationTypesService} from "../services/location-types.service";
import {SitesService} from "../services/sites.service";
import {InjuryClassificationService} from "../services/injury-classification.service";
import {CrashObjectDefinitionService} from "../services/crash-object-definition.service";
import {VehicleDirectionDefinitionService} from "../services/vehicle-direction-definition.service";
import {AccidentPersonTypeService} from "../services/accident-person-type.service";
import {AccidentVehicle} from "../model/accident-vehicle";
import {AccidentVehiclePerson} from "../model/accident-vehicle-person";
import {PersonService} from "../services/person.service";
import {NgxSpinnerService} from 'ngx-spinner';
import { NgxSpinnerModule } from 'ngx-spinner';
import {BaseMessageComponent} from '../common/base-message.component';

declare var $:any;

@Component({
    selector: 'app-accident-detail',
    templateUrl: './accident-detail.component.html',
    styleUrls: ['./accident-detail.component.less'],
    standalone: false
})
export class AccidentDetailComponent extends BaseMessageComponent implements OnInit, DoCheck, AfterContentChecked {

  @ViewChild('mainBody') accidentDetailForm: any;
  accidentClassifications = [];
  accidentCausations = [];
  crashObjects=[];
  injuryClassifications=[];
  vehicledirectiondefinitions=[];
  accidentPersonTypes=[];
  locations = [];
  locationTypes = [];
  sites = [];
  filteredAccidentVehicles = [];
  AreAllVehiclesDeleted=false;
  isAnyPersonAssociatedWithIt = false;
  defaultModalURL = "#driverSearchAdd/?modalpopup=1&accident=1";


  isSuperAdmin = (sessionStorage.getItem("isSuperAdmin") == "true");
  isEditable = (sessionStorage.getItem("isSiteAdmin") === "true");
  public urlPersonID = +this.route.snapshot?.paramMap.get('personId');
  public urlAccidentID = +this.route.snapshot?.paramMap.get('accidentId');

  driver: Driver;
  @Input() persons:Driver[]=[];
  @Input() accident: Accident;
  @Input() accidentVehicles: AccidentVehicle[]=[];
  @Input() accidentVehiclePersons: AccidentVehiclePerson[]=[];

  constructor(private driverService: DriverService,
              private accidentService: AccidentsService,
              private accidentClassificationService: AccidentClassificationService,
              private accidentCausationService: AccidentCausationService,
              private injuryClassificationService: InjuryClassificationService,
              private crashObjectService: CrashObjectDefinitionService,
              private vehicledirectionService: VehicleDirectionDefinitionService,
              private accidentPersonTypeService: AccidentPersonTypeService,
              private siteService: SitesService,
              private locationService: LocationsService,
              private locationTypeService: LocationTypesService,
              private personService: PersonService,
              // private spinnerService: Ng4LoadingSpinnerService,
              private spinnerService: NgxSpinnerService,
              private readonly route: ActivatedRoute,
              cdr: ChangeDetectorRef) {
    super(cdr);
  }

  ngOnInit() {
    if (this.isSuperAdmin)
      this.isEditable = true;

    if (this.urlPersonID != null && this.urlPersonID != 0)
      this.getDriver();
    if (this.urlAccidentID != null && this.urlAccidentID != 0) {
      this.getAccident();
      this.getAccidentVehicles();
    }
    else{
      //new accident
      this.accident= new Accident();
      this.accidentClassificationService.getAll().subscribe(x=>{
        this.accidentClassifications = x;
        this.accident.accidentClassificationId= x[0].accidentClassificationId;
        this.cdr.detectChanges();
      });
      this.accidentCausationService.getAll().subscribe(x=>{
        this.accidentCausations = x;
        this.accident.accidentCausationId= x[0].accidentCausationId;
        this.cdr.detectChanges();
      });
      this.doLookupFields('location');
      this.doLookupFields('site');
      this.doLookupFields('locationType');
    }
  }

  ngDoCheck(){
  }

  ngAfterContentChecked(){
    // disabled all fields if user is not an administrator
    this.disabledEnabledElements(this.isEditable,"*", document.querySelector('#mainBody'));
    document.getElementsByClassName('row showcase-body')[0]?.setAttribute('style','height:100%');

    if (!this.isEditable && document.getElementById('SaveChange')) {
      document.getElementById('SaveChange').outerHTML = '';
      document.getElementById('ResetChange').outerHTML = '';
    }
    if (this.accidentVehiclePersons.length>0){
      let index = this.accidentVehiclePersons.findIndex(x=>x.personId == this.urlPersonID);
      $('#accident_person'+index.toString()).attr('disabled','disabled');
      $('#accident_person_search'+index.toString()).parent().parent().attr('style','background-color:#F2F4F4');
      if (!this.isSuperAdmin) {
        $('#accident_person_search' + index.toString()).attr('disabled', 'disabled');
        $('#accident_vehicle_person_delete_button' + index.toString()).attr('disabled', 'disabled');
      }
    }
  }

  private _ResetWindowSizeAndURL(){
    var iframe = (<HTMLIFrameElement>document.querySelector('#searchPersons'));

    if (!iframe.src.includes(this.defaultModalURL)) {
      iframe.src = this.defaultModalURL;
      iframe.width = "1230px";
      iframe.height = "800px";
      $('.modal-content')[0].style = "min-width: 1232px";
    }
  }

  setDefaultUrl(){
    $('#DriverSearchModal').modal('hide');
    setTimeout(()=>{this._ResetWindowSizeAndURL()},500);
  }

  OpenSearchModal(index:number, personType:number){
    this._ResetWindowSizeAndURL();
    $('button.closeModal').attr('personIndex',index);
    $('button.closeModal').attr('personType',personType);
    $('#DriverSearchModal').modal('show');
  }

  CloseSearch(obj){
    this.setDefaultUrl();
    let personId = +$('button.closeModal').attr('personid');
    let inx = +$('button.closeModal').attr('personIndex');
    let personType = +$('button.closeModal').attr('personType');
    this._getPersonInfo(personType,personId,inx, true);
  }

  getDriver(personId:number=-1) {
    if(personId==-1) personId=this.urlPersonID;
    this.driverService.getDriverByPersonId(personId)
      .subscribe(driver => {
        this.driver = driver;
        $('#BackToDriverPage').attr('onclick','window.location.href="#/driverDetail/'+this.driver.driverID+'"');
        this.cdr.detectChanges();
      });
  }

  getAccident() {
    this.spinnerService.show();
    this.accidentService.getAccidentById(this.urlAccidentID)
      .subscribe(accident => {
        if (accident.accidentTime.length>=8)
          accident.fakeAccidentTime = accident.accidentTime.substr(0,5);
        this.accident = accident;
        this.cdr.detectChanges();
        this.accidentClassificationService.getAll().subscribe(ac => {
          this.accidentClassifications = ac;
          this.cdr.detectChanges();
        });
        this.accidentCausationService.getAll().subscribe(aca => {
          this.accidentCausations = aca;
          this.spinnerService.hide();
          this.cdr.detectChanges();
        });
        this.doLookupFields('location');
      });
    this.doLookupFields('site');
    this.doLookupFields('locationType');
    this.doLookupFields('accidentPersonType');
    this.doLookupFields('injuryClassification');
  }

  getAccidentVehicles(){
    this.spinnerService.show();
    this.doLookupFields('crashObject');
    this.doLookupFields('vehicleDirection');
    this.accidentService.getAccidentVehiclesById(this.urlAccidentID)
      .subscribe(avehicles=>{
        if (avehicles!=null && avehicles.length>0 && avehicles[0].accidentId!=null) {
          this.accidentVehicles = avehicles;
          this.filteredAccidentVehicles = this.accidentVehicles;
        }
        else
          this.accidentVehicles=[];
        this.cdr.detectChanges();
        //this.doLookupFields('projectCode');
        //this.getAccidentPersons();
        this.ResetAccidentPerson(null);
        this.spinnerService.show();
      },(error)=>{},()=>{});
  }

  getAccidentPersons(){
    this.spinnerService.show();
    if (this.accidentVehicles.length>0){
      var itemsProcessed = 0;
      this.accidentVehicles.forEach((av,index,array)=>{
        this.accidentService.getAccidentPersonsByVehicleId(av.accidentVehicleId).subscribe(aperson=>{
          if (aperson!=undefined)
            this.accidentVehiclePersons = this.accidentVehiclePersons.concat(aperson);
          this.cdr.detectChanges();
        },(error)=>{this.spinnerService.hide();},()=>{
          itemsProcessed++;
          if (itemsProcessed === array.length){
            this.persons = new Array<any>(this.accidentVehiclePersons.length);
            this.accidentVehiclePersons.forEach(avp=>{
              let inx = this.accidentVehiclePersons.findIndex(x=>x.personId===avp.personId);
              this._getPersonInfo(avp.accidentPersonTypeId, avp.personId, inx, false);
              this._getInputFieldsForDDL();
            });
            this.spinnerService.hide();
            this.cdr.detectChanges();
          }
        });
      });
    }
  }

  private _getPersonInfo(personType:number,personId:number, index:number,needChecked:boolean=false){
    //this.personTypeGroups[index]=this.accidentPersonTypes;
    this.spinnerService.show();
    this.accidentService.getAccidentPersonByPersonId(personId).subscribe(GenericPerson=>{
      if (needChecked && this.persons.find(x=>x.personID == GenericPerson.personID))
        alert("this Person ( '"+ GenericPerson.lastName + " ," + GenericPerson.firstName+"') already associated with the accident");
      else {
        this.persons[index] = GenericPerson;
        this.accidentVehiclePersons[index].personId=GenericPerson.personID;
      }
      this.spinnerService.hide();
      this.cdr.detectChanges();
    });
  }

  private _getInputFieldsForDDL()
  {
    if (this.accidentPersonTypes.length==0 || this.injuryClassifications.length==0 || this.crashObjects.length==0 || this.vehicledirectiondefinitions.length==0 ) {
      setTimeout(() => {
        this._getInputFieldsForDDL();
      }, 20);
    }
    else {
      this.accidentVehicles.forEach(avehicle=>{
        avehicle.vehicleDirection = this.vehicledirectiondefinitions.find(i=>i.vehicleDirectionDefinitionId == avehicle.vehicleDirectionDefinitionId).vehicleDirection;
        avehicle.crashObjectType = this.crashObjects.find(i=>i.crashObjectDefinitionId == avehicle.crashObjectDefinitionId).crashObjectType;
      });

      this.accidentVehiclePersons.forEach((avperson,index,array) => {
        avperson.injuryClassification = this.injuryClassifications.find(i => i.injuryClassificationId == avperson.injuryClassificationId).injuryClassification;
        avperson.accidentPersonType = this.accidentPersonTypes.find(i => i.accidentPersonTypeId == avperson.accidentPersonTypeId).type;
        avperson.accidentVehicleVIN = this.accidentVehicles.find(i => i.accidentVehicleId == avperson.accidentVehicleId).vin;
      });
      this._areAllVehiclesDeleted();
      this.cdr.detectChanges();
    }
  }

  ChangeAccidentPersonType(ddlIndex:number){
  }

  changeSite(obj,siteId:number){
    this.locations=[];
    this.accident.locationTypeId=null;
    this.accident.siteId=siteId;
  }

  changeLocationType(obj,locationTypeId:number){
    this.locationService.search(this.accident.siteId,this.accident.locationTypeId).subscribe(res=>{
      this.locations=res;
      this.accident.locationId=this.locations[0].locationId;
      this.cdr.detectChanges();
    },(error)=>{
      this.accident.locationId=null;
      alert(error.error.errorCode +" : " + error.error.errorMessage);
    },()=>{});
  }

  private _areAllVehiclesDeleted(){
    if(this.accidentVehicles.find(a=>a.accidentVehicleId>0))
      this.AreAllVehiclesDeleted= false;
    else
      this.AreAllVehiclesDeleted= true;
  }

  private _checkAnyPersonAssociateWithThisVehicle(vehicleId:number){
    if (this.accidentVehiclePersons.find(avp=>avp.accidentVehicleId==vehicleId))
      this.isAnyPersonAssociatedWithIt =true;
    else
      this.isAnyPersonAssociatedWithIt =false;
  }

  ResetAccidentInfo(accidentId:number){
    this.accident=new Accident();
    this.accident.accidentId=accidentId;
    this.getAccident();
  }

  AddAccidentVehicle(tableRef)
  {
    let newVehicle  = new AccidentVehicle();
    newVehicle.accidentId = this.accident.accidentId;
    newVehicle.crashObjectDefinitionId=null;
    newVehicle.vehicleDirectionDefinitionId=null;
    newVehicle.gmVehicleNumber=null;
    newVehicle.vehicleProjectCode=null;
    newVehicle.vin=null;

    this.accidentVehicles.push(newVehicle);
    // we need the following code because make sure remove the option when add new vehicle without save, then this
    // option should not appear to add AccidentVehiclePerson table
    this.filteredAccidentVehicles = this.filteredAccidentVehicles.filter(x=>(x.accidentVehicleId!=null && x.accidentVehicleId>0));

    // setTimeout(()=>{this.disabledEnabledElements(this.isEditable,"*", document.querySelector('#tableEndorsement'));},50);
  }
  deleteAccidentVehicle(accidentVehicleId: number, index: number)
  {
    this._checkAnyPersonAssociateWithThisVehicle(accidentVehicleId);
    if (this.isAnyPersonAssociatedWithIt)
      alert('Cannot Delete this Vehicle since there are person(s) associated with this Vehicle!');
    else {
      var row = document.querySelector('#accident_vehicle' + index.toString()).parentElement.parentElement;
      row.setAttribute('style', 'display:none');
      row.setAttribute('deleted', '1');

      this.accidentVehicles[index].accidentVehicleId = (0-accidentVehicleId);
      this.filteredAccidentVehicles = this.filteredAccidentVehicles.filter(x=>(x.accidentVehicleId!=null && x.accidentVehicleId>0));
    }
  }

  ResetAccidentVehicle(tableRef)
  {

    this.accidentVehicles=[];
    this.getAccidentVehicles();
  }

  AddAccidentPerson(tableRef)
  {
    if (this.accidentVehiclePersons.length>0){
      let person = this.accidentVehiclePersons.find(x=>x.personId==this.urlPersonID);
      if (person==null || person==undefined){
        this._CreateNewPerson(true);
      }
      else
        this._CreateNewPerson();
    }
    if (this.accidentVehiclePersons.length==0) {
      this._CreateNewPerson(true);
    }

  }

  private _CreateNewPerson(defaultToTheDriver:boolean=false){
    let newPerson = new AccidentVehiclePerson();
    newPerson.accidentVehicleId = this.accidentVehicles[0].accidentVehicleId;
    newPerson.injuryClassificationId = null;
    if(defaultToTheDriver) {
      newPerson.personId = this.driver.personID;
      newPerson.accidentPersonTypeId = 1; // default to driver.
    }
    else {
      newPerson.personId = null;
      newPerson.accidentPersonTypeId = null;
    }
    newPerson.accidentVehiclePersonId = null;

    this.accidentVehiclePersons.push(newPerson);
    if (defaultToTheDriver)
      this._getPersonInfo(1,newPerson.personId,0,false);
  }

  deleteAccidentPerson(accidentVehiclePersonId: number, index: number)
  {
    var row =document.querySelector('#accident_vehicle_person_vin'+index.toString()).parentElement.parentElement;
    row.setAttribute('style','display:none');
    row.setAttribute('deleted','1');

    if (accidentVehiclePersonId==null) {
      //delete an new record
      this.accidentVehiclePersons.splice(index,1);
    }
    else
      this.accidentVehiclePersons[index].accidentVehiclePersonId=(0-accidentVehiclePersonId);
  }

  ResetAccidentPerson(tableRef)
  {

    this.accidentVehiclePersons=[];
    this.getAccidentPersons();
  }

  SaveAccident(){
    let accident : Accident = this.accident;
    if (accident.accidentId==0 || accident.accidentId==undefined)
    {
      //brand new accident skipp all update routines
      accident.accidentTime = accident.fakeAccidentTime + ":00";
      this.accidentService.addAccidentInfo(accident).subscribe(value => {
          console.log(accident + " saved.");
          window.location.href="#/accidentDetail/person/"+this.urlPersonID +"/accident/"+ value.accidentId;
        }, (error) => {
          //failed
          this.returnMessage = 'Adding Accident return error: ' + error.status;
          setTimeout(() => {
            this.returnMessage = '';
          }, 2000);
        },
        () => {
          this.returnMessage = 'Adding Accident finished';
          setTimeout(() => {
            this.returnMessage = '';
          }, 2000);
        });
    }
    else {
      // update existing accident base info.
      accident.accidentTime = accident.fakeAccidentTime + ":00";
      this.accidentService.updateAccidentById(accident).subscribe(value => {
          console.log(accident + " saved.");
        accident.accidentTime = accident.fakeAccidentTime + ":00";
        }, (error) => {
          //failed
          this.returnMessage = 'Updating Accident return error: ' + error.status;
          setTimeout(() => {
            this.returnMessage = '';
          }, 2000);
        },
        () => {
          this.returnMessage = 'Updating Accident finished';
          setTimeout(() => {
            this.returnMessage = '';
          }, 2000);
        });

      // accident vehicle portion
      this.accidentVehicles.forEach(x=> {
        if (x.accidentVehicleId == null) {
          //new vehicle
          this.accidentService.addAccidentVehicle(x, this.accident.accidentId).subscribe(value => {
              console.log(x + " saved");
              if (this.accidentVehicles.length==1)
              {
                // only one vehicle, then system should automatically assign the driver to this vehicle
                this.accidentVehicles[0] = value;
                this.AddAccidentPerson(null);
                this.filteredAccidentVehicles = this.accidentVehicles;
              }
            }, (error) => {
              //failed
              this.returnMessage = 'Updating Accident Vehicle return error: ' + error.status;
              setTimeout(() => {
                this.returnMessage = '';
              }, 2000);
            },
            () => {
              this.returnMessage = 'Updating Accident Vehicle finished';
              if (this.accidentVehicles.length>1)
                setTimeout(() => {
                  window.location.href="#/accidentDetail/person/"+this.urlPersonID +"/accident/"+ this.accident.accidentId;
                }, 20);
            });
        }
        else if (x.accidentVehicleId != null && x.accidentVehicleId >0) {
          //do the update vehicle part
          x.accidentId = this.urlAccidentID;
          this.accidentService.updateAccidentVehicleById(x).subscribe(value => {
              x = value;
              console.log(accident + " Vehicle saved.")
            }, (error) => {
              //failed
              this.returnMessage = 'Updating Accident Vehicle return error: ' + error.status;
              setTimeout(() => {
                this.returnMessage = '';
              }, 2000);
              //this.loading = false;
            },
            () => {
              //this.loading = false;
              this.returnMessage = 'Updating Accident Vehicle finished';
              setTimeout(() => {
                this.returnMessage = '';
              }, 2000);
            });
        }
        else if (x.accidentVehicleId != null && x.accidentVehicleId <0) {
          //delete accident vehicle
          x.accidentId = this.urlAccidentID;
          x.accidentVehicleId = (0-x.accidentVehicleId);
          this.accidentService.deleteAccidentVehicleById(x).subscribe(value => {
              console.log(accident + " Vehicle deleted.")
            }, (error) => {
              //failed
              this.returnMessage = 'Deleting Accident Vehicle return error: ' + error.status;
              setTimeout(() => {
                this.returnMessage = '';
              }, 2000);
            },
            () => {
              this.returnMessage = 'Deleting Accident Vehicle finished';
              setTimeout(() => {
                this.returnMessage = '';
              }, 2000);
            });
        }
      });

      // accident person portion
      this.accidentVehiclePersons.forEach(x=>{
        if (x.accidentVehiclePersonId==null){
          //new person
          this.accidentService.addAccidentPerson(x, x.accidentVehicleId).subscribe(value => {
              console.log(x + " saved")
            }, (error) => {
              //failed
              this.returnMessage = 'Adding Accident Person return error: ' + error.status;
              setTimeout(() => {
                this.returnMessage = '';
              }, 2000);
            },
            () => {
              this.returnMessage = 'Adding Accident Person finished';
              setTimeout(() => {
                this.returnMessage = '';
              }, 2000);
            });
        }
        else if (x.accidentVehiclePersonId != null && x.accidentVehiclePersonId >0) {
          //do the update person part
          this.accidentService.updateAccidentPersonById(x).subscribe(value => {
              x = value;
              console.log(accident+ " Vehicle saved.")
            }, (error) => {
              //failed
              this.returnMessage = 'Updating Accident Person return error: ' + error.status;
              setTimeout(() => {
                this.returnMessage = '';
              }, 2000);
            },
            () => {
              //this.loading = false;
              this.returnMessage = 'Updating Accident Person finished';
              setTimeout(() => {
                this.returnMessage = '';
              }, 2000);
            });
        }
        else if (x.accidentVehiclePersonId != null && x.accidentVehiclePersonId <0) {
          //delete accident person
          x.accidentVehiclePersonId = (0-x.accidentVehiclePersonId);
          this.accidentService.deleteAccidentPersonById(x).subscribe(value=>{},(error)=>{
            //failed
            this.returnMessage = 'Deleting Accident Person return error: ' + error.status;
            setTimeout(() => {
              this.returnMessage = '';
            }, 2000);
          },()=>{
            this.returnMessage = 'Deleting Accident Person finished';
            setTimeout(() => {
              this.returnMessage = '';
            }, 2000);
          });
        }
      });
      setTimeout(()=>{
        this._markFormPristine(this.accidentDetailForm);
      },700);
    }
  }

  private _markFormPristine(form): void {
    Object.keys(form.controls).forEach(control => {
      form.controls[control].markAsPristine();
    });
    $.each($('gm-datepicker span'),function (index,value) {
      $(this).hasClass('ng-touched');
      $(this).removeClass('ng-touched').addClass("ng-untouch");
    });
  }

  doLookupFields(fieldName) {
    switch (fieldName){
      case 'location':{
        this.locations=[];
        if (this.accident!=null && this.accident.locationId!=null){
            this.locationService.getLocationById(this.accident.locationId).subscribe(loc=>{
            this.accident.locationTypeId = loc.locationTypeId;
            this.accident.siteId = loc.siteId;
            this.locationService.search(this.accident.siteId,this.accident.locationTypeId) .subscribe(res=>{
              this.locations=res;
              this.cdr.detectChanges();
            });
            this.cdr.detectChanges();
          });
        }
        break;
      }
      case 'locationType':{
        this.locationTypeService.getAll().subscribe(value => {
            this.locationTypes = value;
            this.cdr.detectChanges();
          },
          err => {
            console.log(err);
          },
          () => {
          }
        );
        break;
      }
      case 'site':{
        this.siteService.getAllActivedSites().subscribe(value => {
            this.sites = value;
            this.cdr.detectChanges();
          },
          err => {
            console.log(err);
          },
          () => {}
        );
        break;
      }
      case 'crashObject':{
        this.crashObjectService.getAll().subscribe(value => {
            this.crashObjects = value;
            this.cdr.detectChanges();
          },
          err => {
            console.log(err);
          },
          () => {}
        );
        break;
      }
      case 'injuryClassification':{
        this.injuryClassificationService.getAll().subscribe(value => {
            this.injuryClassifications = value;
            this.cdr.detectChanges();
          },
          err => {
            console.log(err);
          },
          () => {}
        );
        break;
      }
      case 'vehicleDirection':{
        this.vehicledirectionService.getAll().subscribe(value => {
            this.vehicledirectiondefinitions = value;
            this.cdr.detectChanges();
          },
          err => {
            console.log(err);
          },
          () => {}
        );
        break;
      }
      case 'accidentPersonType':{
        this.accidentPersonTypeService.getAll().subscribe(values => {
          this.accidentPersonTypes=values;
          this.cdr.detectChanges();
          },
          err => {
            console.log(err);
          },
          () => {}
        );
        break;
      }
    }
  }

  disabledEnabledElements(enabled: boolean, tagName: string, topObject)
  {
    var all = topObject.querySelectorAll(tagName);

    for (var i = 0, max = all.length; i < max; i++) {
      if (enabled) {
        this.loop(all[i], 'disabled', '');
        if (all[i].tagName=='GM-DATEPICKER' || all[i].tagName=='SELECT') {
          if (all[i].parentNode.getElementsByTagName('INPUT').length>0) {
            all[i].parentNode.getElementsByTagName('INPUT')[0].outerHTML = "";
          }
          if (all[i].tagName=='GM-DATEPICKER')
            all[i].removeAttribute('class');
        }
      }
      else {
        this.loop(all[i],'disabled', 'disabled');
        if (all[i].tagName=='GM-DATEPICKER' || all[i].tagName=='SELECT') {
          if (all[i].parentNode.getElementsByTagName('INPUT').length>0) {
            all[i].parentNode.getElementsByTagName('INPUT')[0].removeAttribute("style");
          }
          all[i].outerHTML = "";
        }
      }
    }
  }

  loop(node, attributeName:string, attributeValue: string) {
    // do some thing with the node here
    if (attributeValue.length>0 && attributeName.length>0) {
      node.setAttribute(attributeName, attributeValue);
    }
    var nodes = node.childNodes;
    for (var i = 0; i < nodes.length; i++) {
      if (!nodes[i]) {
        continue;
      }

      if (nodes[i].childNodes.length > 0) {
        this.loop(nodes[i],attributeName, attributeValue);
      }
    }
  }
}
